import { link } from '@/constants/link';
import { apiCaller } from '@/redux/query';

/**
 * Returns the deep link URL to open the App Embed activation editor for the current shop.
 * Prefers the URL provided by the backend (theme-aware, works for both OS 2.x and OS 3.0),
 * falls back to the static themes admin page until the API responds.
 */
export const useAppEmbedDeepLink = (): string => {
  const { data } = apiCaller.useCheckAppEmbedStatusQuery();
  return data?.deepLinkUrl || link.isOpenAppEmbedUrl;
};
